<template>
  <b-container fluid>
    <PortalNavbar></PortalNavbar>
    <div class="body-wrapper">
      <div class="body-title">
        <h5 style="color: #2284ab">List of Qualified Candidates:</h5>
        <b-table
          show-empty
          head-variant="dark"
          empty-text="No List available at this time. Keep Looking this space."
          stacked="md"
          bordered
          striped
          :items="events"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          @filtered="onFiltered"
          style="font-size: 12px"
          class="mt-3"
        >
          <template slot="GroundMerit" slot-scope="row">
            <b-button
              size="sm"
              @click.stop="showDetails(row.item, row.index, 1)"
              class="mr-1 pt-0 pb-0"
              variant="success"
              v-b-tooltip.hover
              title="View Details"
            >
              View
            </b-button>
          </template>
          <template slot="MedicalMerit" slot-scope="row">
            <b-button
              size="sm"
              @click.stop="showDetails(row.item, row.index, 2)"
              v-if="row.item.PublishMeritListMed"
              class="mr-1 pt-0 pb-0"
              variant="primary"
              v-b-tooltip.hover
              title="View Details"
            >
              View
            </b-button>
          </template>
        </b-table>
      </div>
    </div>
    <b-modal
      ref="myModalRef"
      id="modal1"
      scrollable
      title="Qualification List"
      size="lg"
    >
      <b-row>
        <b-col md="4">
          <b-form-group
            id="exampleInputGroup2"
            horizontal
            label="Gender <span style='color:red'>*</span>"
            label-size="sm"
            label-for="radiosg"
          >
            <b-form-radio-group
              id="radiosg"
              size="sm"
              v-model="MeritType"
              @change="meritChange"
            >
              <b-form-radio value="0">All</b-form-radio>
              <b-form-radio value="1">Male</b-form-radio>
              <b-form-radio value="2">Female</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-for="category in meritlist_category" :key="category.id">
        <h6 class="ml-1" v-if="category.id != 'ALL'">Category: {{category.id}}</h6>
        <b-row class="m-2">
          <b-col
            md="1"
            class="mt-1"
            v-for="application in category.value"
            :key="application.ApplicationNo"
          >
            <span class="border border-primary">{{
              application.ApplicationNo
            }}</span>
          </b-col>
        </b-row>
      </div>
      <!-- <b-table show-empty head-variant="dark"
            empty-text="No List available at this time. Keep Looking this space."
            stacked="md"
            bordered
            striped 
            :items="meritlist"
            :fields="fieldsMerit"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            @filtered="onFiltered"
            style="font-size:12px"    
            class="mt-3"
        ></b-table> -->
    </b-modal>
  </b-container>
</template>

<script>
import apis from "../apis";
import Spinner from "vue-simple-spinner";
import PortalNavbar from "@/components/PortalNavbar";
import * as _ from "lodash";

export default {
  components: { Spinner, PortalNavbar },
  data() {
    return {
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: true,
      isLoading2: false,
      meritlist: [],
      meritlist_category: {},
      events: [
        {
          EventTitle: "",
          ApplicationStartDt: "",
          ApplicationEndDt: "",
          EventID: "",
          EventDetailsFile: "",
          BoardID: "",
          ApplyStatus: false,
          BoardName: "N/A",
        },
      ],
      itemsa: [],
      counter: 0,
      max: 0,
      fields: [
        { key: "BoardName", label: "Board Name", sortable: true },
        { key: "EventTitle", label: "Job Title", sortable: true },
        { key: "GroundMerit", label: "Ground Pass" },
        { key: "MedicalMerit", label: "Medical Pass" },
      ],
      fieldsMerit: [
        { key: "ApplicationNo", label: "Application No", sortable: true },
        { key: "Gender", label: "Gender", sortable: true },
        { key: "MeritRank", label: "Merit Rank", sortable: true },
        { key: "Height", label: "Height cm" },
        { key: "Weight", label: "Weight kg" },
        { key: "RunningMarks", label: "Running Marks" },
        { key: "PullupMarks", label: "Pullup Marks" },
        { key: "SitupMarks", label: "Situp Marks" },
        { key: "EducationMarks", label: "Education Marks" },
        { key: "TotalMarks", label: "Total Marks" },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedEventId: "",
      RegType: 0,
      MeritType: 0,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    getRegTyp() {
      let x = this.$store.getters.getRegTyp;
      //console.log (x);
      return x;
    },
  },
  methods: {
    meritChange(val) {
      //alert(val);
      this.MeritType = val;
      this.showDetailsSub();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showDetails(item, index, type) {
      //this.$refs.myModalRef.show();
      //return;
      this.selectedEventId = item.EventID;
      this.RegType = type;
      this.showDetailsSub();
    },
    showDetailsSub() {
      let promise = apis.getEventMeritbyId(
        this.selectedEventId,
        this.RegType,
        this.MeritType
      );
      promise
        .then((response) => {
          if (response.status == 200) {
            //console.log("Items", response.body);
            this.isLoading = false;
            //this.itemsa.push(response.body);

            this.meritlist = response.body;
            let origin = _.groupBy(this.meritlist, (x) => x.MeritCategory);

            this.meritlist_category = Object.entries(origin).map(
              ([key, value]) => ({ id: key, value })
            );
            //console.log(this.meritlist_category);

            this.$refs.myModalRef.show();
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
            this.isLoading = false;
            //this.itemsa = [];
            this.meritlist = [];
          }
        })
        .catch((err) => {
          alert(err.body);
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
          this.items = [];
        });
    },
  },
  mounted() {
    this.events = [];

    this.isLoading = true;
    let promise = apis.getMeritEvents();

    promise
      .then((response) => {
        if (response.status == 200) {
          this.events = response.body;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
        this.isLoading = false;
      })
      .catch((err) => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
        this.isLoading = false;
      });
  },
};
</script>

<style scope>
.modal-dialog {
  width: 80%;
}
.modal-lg {
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/MeritList.vue